import type { PropsWithChildren } from 'react';
import { Children } from 'react';
import '@/components/numbered-list/numbered-list.css';

export default function NumberedList(props: PropsWithChildren) {
  const { children } = props;

  return (
    <ul className='numbered-list'>
      {Children.map(children, (child, idx) => (
        <li data-testid='numbered-list-item' className='numbered-list__item'>
          <div className='numbered-list__circle'>{idx + 1}</div>
          <div className='numbered-list__content'>
            {typeof child === 'string' ? (
              <div
                data-testid='numbered-list-string'
                className='numbered-list__text'
                dangerouslySetInnerHTML={{ __html: child }}
              />
            ) : (
              <div data-testid='numbered-list-component' className='numbered-list__text'>
                {child}
              </div>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
